<lib-dialog-layout-inner-x
  minHeight="100px"
  (close)="closeDialog()"
  [title]="data?.title"
  [closeIconPath]="data.closeIconPath"
>
  <ng-template #content>
    @if (data?.descriptionHtml) {
      <span class="description" [innerHTML]="data.descriptionHtml"></span>
    }
    @if (data.additionalBoolean) {
      <br />
      <hr />
      @if (data.additionalBoolean.type === 'slide') {
        <mat-slide-toggle class="slide-toggle" [formControl]="slideControl"
          >{{ data.additionalBoolean.label }}!</mat-slide-toggle
        >
      }
    }
  </ng-template>
  <ng-template #actions>
    <div class="btn-container">
      <button class="btn btn-primary" (click)="handleConfirm()">{{ data.confirmBtn }}</button>
      @if (!hidecancelBtn) {
        <button class="btn btn-secondary" (click)="closeDialog()">
          {{ 'global.cancel' | transloco }}
        </button>
      }
    </div>
  </ng-template>
</lib-dialog-layout-inner-x>
